<!--
  ConfirmDialog.vue
    Confirm Dialog Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-dialog v-model="mVisible" max-width="500px">
    <div class="hm-dlg">
      <div class="hm-bg-prim-blue hm-dlg-title">
        <v-icon color="white">info</v-icon>
        <span class="hm-eid-title">Confirmation</span>
      </div>
      <div class="hm-eid-msg">
        <slot name="msg"></slot>
      </div>
      <v-btn flat color="primary" @click="onClickOk">OK</v-btn>
      <v-btn flat color="secondary" @click="onClickCancel">CANCEL</v-btn>
    </div>
  </v-dialog>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>

export default {
  name: 'ConfirmDialog',
  data: () => ({
    mVisible: false,
    okCallback: null,
  }),
  mounted: function () {
    this.$log.debug('# ConfirmDialog')
    // showイベントハンドラを登録
    this.$on('show', this.show)
  },
  destroyed: function () {
    this.$log.debug('# ConfirmDialog')
  },
  methods: {
    show: function (callback) {
      this.mVisible = true
      if (callback !== null) {
        this.registOkCallback(callback)   // コールバック関数を設定
      }
    },
    onClickOk: function () {
      this.mVisible = false
      if (this.okCallback !== null) {
        this.okCallback()     // コールバック関数を実行
      }
    },
    onClickCancel: function () {
      this.mVisible = false
    },
    registOkCallback (callback) {
      this.okCallback = callback
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-dlg {
  text-align: center;
  background-color: whitesmoke;
}
.hm-dlg-title {
  padding: 20px;
  margin-bottom: 30px;
  color: white;
  font-size: 1.2em;
  font-weight: bold;
}
.hm-eid-title {
  margin-left: 10px;
}
.hm-eid-msg {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/ConfirmDialog.vue